import { IStopFormTimeWindow } from '../../../components/orders/OrderForm/orderFormHelpers';
import { Instance } from 'mobx-state-tree';
import moment, { Moment } from 'moment';
import { hrsMinFormat, twelveHrsMinFormat } from '../../../constants';
import { VisitTimeWindowDtoModelBase } from './VisitTimeWindowDtoModel.base';
import getAppRoot from '../utils/getAppRoot';
import { DateTimeFormat } from './DateTimeFormatEnum';

/* The TypeScript type of an instance of VisitTimeWindowDtoModel */
export interface VisitTimeWindowDtoModelType extends Instance<typeof VisitTimeWindowDtoModel.Type> {
}

/* A graphql query fragment builders for VisitTimeWindowDtoModel */
export {
  selectFromVisitTimeWindowDto, visitTimeWindowDtoModelPrimitives, VisitTimeWindowDtoModelSelector,
} from './VisitTimeWindowDtoModel.base';

/**
 * VisitTimeWindowDtoModel
 */
export const VisitTimeWindowDtoModel = VisitTimeWindowDtoModelBase
  .views(self => ({
    get timeWindowObject(): IStopFormTimeWindow | undefined {
      if (self.startTime === null) {
        return { startTime: undefined, endTime: self.endTime === null ? undefined : self.endTime };
      }
      if (self.endTime === null) {
        return { startTime: self.startTime === null ? undefined : self.startTime, endTime: undefined };
      }
      return (self.startTime !== undefined || self.endTime !== undefined) ? { startTime: self.startTime, endTime: self.endTime } : undefined;
    },
    get startTimeMoment(): Moment | undefined {
      return self.startTime ? moment.utc(self.startTime, hrsMinFormat) : undefined;
    },
    get endTimeMoment(): Moment | undefined {
      return self.endTime ? moment.utc(self.endTime, hrsMinFormat) : undefined;
    },
    get momentArray(): [Moment, Moment] | undefined {
      return (this.startTimeMoment && this.endTimeMoment) ? [this.startTimeMoment, this.endTimeMoment] : undefined;
    },
    get startTimeString(): string | undefined {
      return getAppRoot(self).organization.settings.dateTimeFormat === DateTimeFormat.MILITARY ? this.startTimeMoment?.format(hrsMinFormat) : this.startTimeMoment?.format(twelveHrsMinFormat);
    },
    get endTimeString(): string | undefined {
      return getAppRoot(self).organization.settings.dateTimeFormat === DateTimeFormat.MILITARY ? this.endTimeMoment?.format(hrsMinFormat) : this.endTimeMoment?.format(twelveHrsMinFormat);
    },
    get stringArray(): [string, string] | undefined {
      return (this.startTimeString && this.endTimeString) ? [this.startTimeString, this.endTimeString] : undefined;
    },
    get formattedString(): string | undefined {
      const startTime = this.startTimeString;
      const endTime = this.endTimeString;

      if (startTime && endTime) {
        return `${startTime} – ${endTime}`;
      }
      if (startTime) {
        return startTime;
      }
      if (endTime) {
        return endTime;
      }

      return undefined;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
